import { LegalPage } from './_LegalPage';

export function Privacy() {
  return <LegalPage docKey="privacy" />;
}
